import { usePathname } from 'next/navigation';
import { memo } from 'react';
import OfferSchema from './OfferSchema';
import { Entry } from 'contentful';
import { ExtendedProductFields } from '@/core/contentfulConfig';
import { buildProductUrl } from './productUrl';

export interface ProductSchemaProps {
  product: Entry<ExtendedProductFields>;
  url?: string; // Required when appearing outside of a product page
}

const ProductSchema = ({ product, url }: ProductSchemaProps) => {
  const pathname = usePathname();
  const imageUrl = product.fields.featuredImage?.fields.Image?.fields.file?.url;
  const productUrl = url || buildProductUrl(pathname);
  const variant = product.fields.shopifyProduct?.variants[0];

  return (
    <div>
      <meta itemProp="name" content={product.fields.title} />
      <meta itemProp="url" content={productUrl} />
      <meta itemProp="brand" content="Lovevery" />
      <meta itemProp="image" content={imageUrl} />
      <meta itemProp="description" content={product.fields.shortDescription} />
      {variant && (
        <OfferSchema
          variant={variant}
          url={productUrl}
          isPlayKit={product.fields.isPlayKit}
        />
      )}
    </div>
  );
};

export default memo(ProductSchema);
